import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  ThemeProvider,
  Box,
  Card,
  Grid,
  createMuiTheme,
  CardContent,
  makeStyles
} from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import FolderIcon from '@material-ui/icons/Folder';
import { deepOrange } from '@material-ui/core/colors';
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
// import Cookies from 'universal-cookie';
import _, { isUndefined, isEmpty, isNull } from 'lodash';
import { Helmet } from 'react-helmet';
import Cookies from 'universal-cookie';

import './index.scss';
import Navbar from '../../components/Navbar';

/**Connections */
import { METADATA } from '../../constants';
import OutlinedCard from '../../components/FileUpload/Cards';
import StandaloneToggleButton from '../../components/FileUpload/Folders';
import CustomizedSelects from '../../components/FileUpload/Dropdowns';
import { uploadContentService } from '../../services';
import ButtonBase from '@material-ui/core/ButtonBase';


const theme = createMuiTheme({
  root: {
    maxWidth: 345,
  },
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: deepOrange[500],
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#11cb5f',
    },
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },
});

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: deepOrange[500],
  },
  buttonFolderStepper: {
    color: 'white',
    marginLeft: '15px'
  },
  iconFolderStepper: {
    fontSize: '15px',
    color: 'white'
  },
  buttonFolderStepperActive: {
    color: '#f60',
    marginLeft: '15px'
  },
  iconFolderStepperActive: {
    fontSize: '15px',
    color: '#f60'
  }
}))

export default function UploadContent() {
  const classes = useStyles();
  const cookies = new Cookies();

  const [uploadContents, setUploadContents] = useState([]);
  const [uploadContentLists, setUploadContentLists] = useState([]);
  const [taggedPlaylist, setTaggedPlaylist] = useState([]);
  const [taggedContentUnitList, setTaggedContentUnitList] = useState([]);
  const [totalUploadContents, setTotalUploadContents] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const { user } = useSelector(state => state.userAuthentication);

  let [folderStepper, setFolderStepper] = useState([{
    name: 'ALT',
    isActive: true,
    position: 1
  }]);

  const getUploadedContents = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.uploadContent(user);
      setTotalUploadContents(res?.items.length);
      setUploadContentLists(res?.items);
      setUploadContents(res?.items);
    }
  }, [user]);

  useEffect(() => {
    getUploadedContents();
  }, [getUploadedContents]);

  const fetchTaggedPlaylists = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.taggedPlaylists(user);
      setTaggedPlaylist(res?.items);
    }
  }, [user]);

  useEffect(() => {
    fetchTaggedPlaylists();
  }, [fetchTaggedPlaylists]);

  const fetchTaggedContentUnitLists = useCallback(async () => {
    if (!isUndefined(user)) {
      const marker = '';
      const res = await uploadContentService.taggedContentUnitList(user, marker);
      setTaggedContentUnitList(res?.devices);
    }
  }, [user]);

  useEffect(() => {
    fetchTaggedContentUnitLists();
  }, [fetchTaggedContentUnitLists]);

  const processTaggedPlaylistsPresentation = () => {
    let taggedPlaylistArr = [];
    let taggedContentUnitListArr = [];

    if (!isUndefined(taggedPlaylist)) {
      [...taggedPlaylist].map(item => {
        const presentations = item.presentations;

        [...presentations].map(pres => {
          taggedPlaylistArr.push(pres.name);
        });
      });
    }

    if (!isUndefined(taggedContentUnitList)) {
      [...taggedContentUnitList].map(item => {
        const presentation = item.presentation;
        taggedContentUnitListArr.push(presentation.name);
      });
    }

    processCrossmatchingPresentations(taggedPlaylistArr, taggedContentUnitListArr);
  }

  const processCrossmatchingPresentations = (presentation1, presentation2) => {
    if (!isUndefined(presentation1) && !isUndefined(presentation2)) {
      const newArr = _.uniqBy(presentation2, 'id')

      if (presentation1.includes(newArr[0])) {
        cookies.set('hasTaggedPlaylist', true);
      } else {
        cookies.set('hasTaggedPlaylist', false);
      }
    }
  }

  processTaggedPlaylistsPresentation();

  const getUploadContentSubfolder = useCallback(async (data) => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.uploadContentSubfolder(user, data);
      setTotalUploadContents(res?.items.length);
      setUploadContentLists(res?.items);
      setUploadContents(res?.items);
    }
  }, [user]);

  const handleClickFolder = (event) => {
    const data = event.currentTarget.dataset.value;
    const position = 1;
    let stringVal = "";

    folderStepper.map(item => {
      if (item.position > position) {
        const newString = stringVal.concat(item.name, "/", data, "/");
        stringVal = newString;
        getUploadContentSubfolder(stringVal);

        return newString;
      } else {
        getUploadContentSubfolder(data);
        return stringVal;
      }
    });
    setUploadContentLists([]);
    setUploadContents([]);
    let folders = appendFolderStepper(data);
    setFolderStepper(folders);
  }

  const handleClickFolderStepper = async (data) => {
    setUploadContentLists([]);
    setUploadContents([]);
    let folders = removeExcessFolderStepper(data);
    folders = setActiveFolderStepper(data, folders);
    setFolderStepper(folders);
    if (!isUndefined(user)) {
      if (data.position === 1) {
        const res = await uploadContentService.uploadContent(user);
        setTotalUploadContents(res?.items.length);
        setUploadContentLists(res?.items);
        setUploadContents(res?.items);
      } else {
        const res = await uploadContentService.uploadContentSubfolder(user, data.name);
        setTotalUploadContents(res?.items.length);
        setUploadContentLists(res?.items);
        setUploadContents(res?.items);
      }
    }
  }

  const appendFolderStepper = (data) => {
    let folders = folderStepper;
    folders.map(a => a.isActive = false);
    folders.push({
      name: data,
      position: (Math.max.apply(Math, folders.map(function (o) { return o.position; }))) + 1,
      isActive: true
    });
    folders = folders.sort(function (a, b) {
      return a.position - b.position
    });
    return folders;
  }

  const removeExcessFolderStepper = (data) => {
    let folders = folderStepper;
    folders = folders.filter(x => x.position <= data.position);
    return folders;
  }

  const setActiveFolderStepper = (data, folders) => {
    let selectedFolder = folders.filter(x => x.position === data.position)[0];
    selectedFolder.isActive = true;
    folders = folders.filter(x => x.position !== data.position);
    folders.push(selectedFolder);
    folders = folders.sort(function (a, b) {
      return a.position - b.position
    });
    return folders;
  }

  const fetchMoreData = () => {
    if (!isUndefined(uploadContents) && !isNull(uploadContents) && !isUndefined(totalUploadContents) & !isNull(totalUploadContents)) {
      if (uploadContents.length >= totalUploadContents) {
        setHasMore(false);
        return;
      }

      // a fake async api call like which sends
      // more records in .5 secs
      setTimeout(() => {
        setUploadContentLists([...uploadContents].concat(uploadContents));
      }, 500);
    }
  }

  useEffect(() => {
    if (!isUndefined(uploadContentLists) || !isEmpty(uploadContentLists)) {
      window.localStorage.setItem('uploadedContent', JSON.stringify(uploadContentLists));
    }
  }, [uploadContentLists]);

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.UPLOADCONTENT.description} />
        <title>{METADATA.UPLOADCONTENT.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center">
        <Grid
          className="dashboard-content main-menu"
          justify="center"
          xs={12}
          md={12}
          lg={12}>
          <div className="positionText">
            <div className="inner-content">
              <PublishIcon />
            </div>
            <h1 className="title" >
              Handter
            </h1>
          </div>
          <div className="positionButton">
            <ThemeProvider theme={theme} >
              <Button className="buttonStyle" color="primary" variant="contained" >Upload</Button>
            </ThemeProvider>
          </div>

          {/* Here start the code for card media content */}
          <Card className="card-main">
            <Grid container>
              {
                folderStepper.map(item => {
                  return (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClickFolderStepper(item);
                      }}
                      className={item.isActive === false ?
                        classes.buttonFolderStepper :
                        classes.buttonFolderStepperActive}
                      type="button"
                      startIcon={<FolderIcon className={item.isActive === false ?
                        classes.iconFolderStepper :
                        classes.iconFolderStepperActive} />}
                    >
                      {item.name}
                    </Button>
                  )
                })
              }
            </Grid>

            <InfiniteScroll
              dataLength={!isUndefined(uploadContentLists) ? uploadContentLists.length : 0}
              next={fetchMoreData}
              style={{ width:"100%" }}
              hasMore={hasMore}
              height={750}
            >
              <CardContent className="card-content" >
                <Box className="card-box" >
                  <Grid className="grid-menu-container" container spacing={0} item justify="center">
                    {
                      isUndefined(uploadContentLists) || isEmpty(uploadContentLists) || isNull(uploadContentLists) ? (
                        <div className={classes.loader}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <Grid container>
                          {
                            [...uploadContentLists].filter(x => x.mediaType === "Folder").map(item => {
                              if (item) {
                                return (
                                  <ButtonBase className="content-folder" data-value={item.name} onClick={handleClickFolder}>
                                    <Grid >
                                      <StandaloneToggleButton className="folder-icon" item xs={12} sm={5} md={2} />
                                      <h4 className="content-folder-label">{item.name}</h4>
                                    </Grid>
                                  </ButtonBase>
                                )
                              } else {
                                return null
                              }
                            })
                          }
                          {
                            [...uploadContentLists].filter(x => x.mediaType !== "Folder").map(item => {
                              if (item) {
                                return (
                                  <Grid  item xs={12} sm={3} md={2} className="media-cards"  style={{position:"relative"}} >
                                    <CustomizedSelects id={item.id} />
                                    <OutlinedCard fileImage={item.thumbPath} filename={item.fileName}  fileType={item.mediaType} />
                                  </Grid>
                                )
                              } else {
                                return null
                              }
                            })
                          }
                        </Grid>
                      )}
                  </Grid>
                </Box>
              </CardContent>
            </InfiniteScroll>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}